

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import Deposit from './components/Deposit'
import DepositQrcode from './components/Qrcode'
import Finished from './components/Finished'
import Error from './components/Error'
import BankDetails from './components/BankDetails'
import HelpCenter from './components/HelpCenter'
import axios from 'axios'
import Deposit2 from './components/Deposit2'
import Deposit2Dark from './components/Deposit2Dark'
import Models from './models'
import UserInfo from './components/UserInfo'
import VueI18n from 'vue-i18n'

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(AjaxPlugin)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(VueI18n) 
Vue.use(VueRouter)

const routes = [
{
path: '/',
component: Deposit
},
{
path: '/m2',
component: Deposit2
},
{
path: '/m3',
component: Deposit2Dark
},
{
path: '/qrcode',
name: 'deposit-qrcode',
component: DepositQrcode
},
{
path: '/finished',
name: 'finished',
component: Finished
},
{
path: '/error',
name: 'error',
component: Error
},
{
path: '/bankdetails',
name: 'bankdetails',
component: BankDetails
},
{
path: '/helpcenter',
name: 'helpcenter',
component: HelpCenter
},
{
path: '/userinfo',
name: 'userinfo',
component: UserInfo
}
]

let mode
if (window.location.hash === '') {
mode = 'history'
} else {
mode = 'hash'
}

const router = new VueRouter({
routes,
mode: mode
})

FastClick.attach(document.body)

Vue.config.productionTip = false

axios.defaults.withCredentials = true

Vue.use(Models)

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js